import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'app-fixed-text-area',
  templateUrl: './fixed-text-area.component.html',
  styleUrls: ['./fixed-text-area.component.scss'],
  providers: [],
})
export class FixedTextAreaComponent {
  @ViewChild('textarea') textarea: any;

  @Input() value: string = '';
  @Input() rows: number = 25;
  @Output() scrolledEnded: EventEmitter<boolean> = new EventEmitter<boolean>();

  loading: boolean = false;
  hasScrolledToEnd: boolean = false;

  constructor() {}

  ngOnInit() {}

  ngAfterViewInit() {
    const textArea = this.textarea.nativeElement;
    if (this.textarea) {
      const isScrolledToBottom = textArea.scrollTop + textArea.clientHeight >= textArea.scrollHeight;
      if (isScrolledToBottom) {
        this.hasScrolledToEnd = true;
        this.scrolledEnded.emit(true);
      }
    }
  }

  onScroll(textarea: HTMLTextAreaElement): void {
    const isScrolledToBottom = textarea.scrollTop + textarea.clientHeight >= textarea.scrollHeight;

    if (isScrolledToBottom && !this.hasScrolledToEnd) {
      this.hasScrolledToEnd = true;
      this.scrolledEnded.emit(true);
    }
  }
}
